import { LitElement, html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { ButtonOption } from '../../services/types.js';
import styles from '../../styles/mariana-normal-buttons.css?inline';

/**
 * Dynamic Buttons Component
 * Renders action buttons from BFF responses
 */
@customElement('mariana-normal-buttons')
export class MarianaButtonsNormal extends LitElement {
  static readonly styles = unsafeCSS(styles);

  @property({ type: Array })
  buttons: ButtonOption[] = [];

  private handleClick(button: ButtonOption) {
    this.dispatchEvent(new CustomEvent('button-click', {
      detail: button,
      bubbles: true,
      composed: true,
    }));
  }

  render() {
    if (!this.buttons || this.buttons.length === 0) {
      return html``;
    }

    return html`
      <div class="button-container">
        ${this.buttons.map((button) => html`
          <button
            class="dynamic-button"
            @click=${() => this.handleClick(button)}
            type="button"
          >
            ${button.label}
          </button>
        `)}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mariana-normal-buttons': MarianaButtonsNormal;
  }
}
